import { render } from "./SettingMenu.vue?vue&type=template&id=25404668&scoped=true"
import script from "./SettingMenu.vue?vue&type=script&lang=js"
export * from "./SettingMenu.vue?vue&type=script&lang=js"

import "./SettingMenu.vue?vue&type=style&index=0&id=25404668&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25404668"]])

export default __exports__